import { useConfirmationStore } from '@/platform/stores/useConfirmationStore';
import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/platform/ui';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

// Mounted once by the layout so any view can open a confirmation through
// useConfirmationStore().confirm({ title, description, onConfirm, ... })
// without rendering its own dialog.
const Confirmation = () => {
    const { open, loading, options, close } = useConfirmationStore();
    const {
        title = 'Weet je het zeker?',
        description,
        confirmLabel = 'Bevestigen',
        cancelLabel = 'Annuleren',
        variant = 'danger',
        icon = <ExclamationTriangleIcon />,
        onConfirm,
    } = options;

    return (
        <Modal
            open={open}
            onClose={loading ? undefined : close}
            size='medium'
            icon={icon}
            iconVariant={variant}
        >
            <ModalHeader>{title}</ModalHeader>
            {description && (
                <ModalContent className='text-sm text-gray-500'>
                    {description}
                </ModalContent>
            )}
            <ModalActions>
                <Button data-autofocus disabled={loading} onClick={close}>
                    {cancelLabel}
                </Button>
                <Button
                    variant={variant}
                    loading={loading}
                    onClick={() => onConfirm?.(close)}
                >
                    {confirmLabel}
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default Confirmation;
